export interface GlobalState {
    notifications: null | {
        id: string,
        notification: string,
        type: 'info' | 'error'
    }[];
    breadcrumb: {
        level1?: {
            name: string,
            routerLink?: string,
            routerQueryParams?: any,
            routerFragment?: string
        }
        level2?: {
            name: string,
            routerLink?: string,
            routerQueryParams?: any,
            routerFragment?: string
        }
    },
    locations?: {
        article: {
            id: string,
            listRouterUrl: any,
            listQueryParams: any;
        }
    },
    selected: {
        group: string | null,
        group1: string | null,
        articleView: string
    },
    groups?: {
        name: string,
        pos: number,
        groups1?: {
            name: string,
            pos: number
        }[]
    }[],
    dynamicPageLinks?: {
        linkPositions: ('top' | 'b2b_foot' | 'foot_0' | 'foot_1' | 'foot_2')[];
        uniqueName: string;
        externalLinkUrl?: string;
        routerLink?: string;
        name: string;
    }[],
    visitedArticles?: string[],
    visibilities: {
        userLogin: boolean,
        userLostPassword: boolean,
        mobileMenu: boolean,
        mobileGroups: boolean,
        filterMenu: boolean
    },
    SEO?: {
        title: string,
        description: string,
        keywords: string,
        useForUrl: string
    }
}

export const initialGlobalState = (): GlobalState => {
    return {
        notifications: null,
        breadcrumb: {},
        selected: {
            group: null,
            group1: null,
            articleView: 'gallery'
        },
        visibilities: {
            userLogin: false,
            userLostPassword: false,
            mobileMenu: false,
            mobileGroups: false,
            filterMenu: false
        }
    };
};
